import { storyblokEditable, StoryblokRichText, BlockTypes } from "@storyblok/react";
import styleVariables from "@utils/styleVariables";
import classNames from "classnames";

const styles = styleVariables();

function ClosetPromoBanner({ blok }) {
  if (!blok || !blok.show) return null;

  const resolvers = {
    [BlockTypes.PARAGRAPH]: (node) => (
      <p
        className={classNames(
          "mb-0 text-2-lines font-size-sm closet-promo-banner-text-container",
          `text-${blok.text_color}`,
        )}
      >
        {node.children}
      </p>
    ),
  };

  return (
    <div
      key={blok._uid}
      {...storyblokEditable(blok)}
      className={blok.show ? "text-center p-2" : "d-none"}
      style={{ backgroundColor: blok.background_color || styles.tertiary }}
    >
      <StoryblokRichText
        doc={blok.text}
        resolvers={resolvers}
      />
    </div>
  );
}

export default ClosetPromoBanner;
